module.exports = __webpack_public_path__ + "static/img/13.7509297.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/sp/13.png
// module id = ke+k
// module chunks = 0